import { Component, OnInit } from '@angular/core';
import { Proveedor } from '../factoring/interface/data.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { Observable } from 'rxjs';
import { PortfolioService } from '../service/portfolio.service';
import { CompanyPortfolioAssignmentDTO, FilterCompanyAssignmentViewModel, PortfolioDTO, SelectedCompanyAssignmentToMarkUnmarkFavorite } from './interface/portfolio.interface';
import { FilterPagination } from '../files-clients/interface/company-client.interface';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss'],
})
export class PortfolioComponent implements OnInit{
  public providerSummaries: PageResult<Proveedor>;
  public pagination: FilterPagination;
  public filter: FilterCompanyAssignmentViewModel;
  public myPortfolios$: Observable<Array<PortfolioDTO>>;
  public myCompanyPortfolioAssignations$: Observable<PageResult<CompanyPortfolioAssignmentDTO>>;

  constructor(
    private portfolioService: PortfolioService,
  ) {
    this.myPortfolios$ = new Observable<Array<PortfolioDTO>>;
    this.pagination = {
      page: 1,
      pageSize: 10
    };

    this.filter = {
      search: '',
      favorite: '',
    };
  }

  ngOnInit(): void {
    this.getMyCompaniesPortfolioAssignation();
    this.myPortfolios$ = this.getMyPortfolios();
  }

  getMyPortfolios() :Observable<Array<PortfolioDTO>>{
    return this.portfolioService.getMyPortfolios();
  }

  public receivePaginationClients(updatedPagination: FilterPagination) {
    this.pagination = {
      ...this.pagination,
      page: updatedPagination.page,
      pageSize: updatedPagination.pageSize
    };
    this.getMyCompaniesPortfolioAssignation();
  }

  receiveUpdatedFilters(updatedFilters: FilterCompanyAssignmentViewModel) {
    this.filter = {
      ...this.filter,
      search: updatedFilters.search,
      favorite: updatedFilters.favorite,
    };

    this.getMyCompaniesPortfolioAssignation();
  }

  getMyCompaniesPortfolioAssignation(){
    this.myCompanyPortfolioAssignations$ = this.portfolioService.getAssignCompaniesFromMyPortfolio(this.pagination, this.filter);
  }

  receiveCompanyToMarkAsFavorite(request: SelectedCompanyAssignmentToMarkUnmarkFavorite): void {
    this.portfolioService.markAssignCompanyAsFavorite(request)
    .subscribe({
      next: (res) => {
        this.getMyCompaniesPortfolioAssignation();
      }
    })
  }

  receiveCompanyToUnmarkAsFavorite(request: SelectedCompanyAssignmentToMarkUnmarkFavorite): void {
    this.portfolioService.unmarkAssignCompanyAsFavorite(request)
    .subscribe({
      next: (res) => {
        this.getMyCompaniesPortfolioAssignation();
      }
    })
  }

}
